import React, { useState } from "react";
import { Form, Formik, FormikValues } from "formik";
import InputField from "../../../shared/components/InputField";
import { loginFormValidation } from "./LoginValidation";
import { Button } from "antd";
import AuthService from "../../../services/AuthService/auth.service";
import "./loginForm.scss";
import { Doctor } from "../../../models/Doctor/doctor.model";
import { UserRoleEnum } from "../../../enums/userRole.enum";
import { Admin } from "../../../models/Admin/admin.model";
import { ScanCenter } from "../../../models/ScanCenter/scanCenter.model";
import AuthContainer from "../../../store/container/AuthContainer";
import { AuthReducerProps } from "../../../store/reducers/authReducer";
import { useHistory } from "react-router-dom";
import { AppRoutes } from "../../../routes/routeConstants/appRoutes";
import RadiolinqLogo from "../../../assets/images/blue_logo.png";

interface User {
  email: string;
  password: string;
}

const initialValue = {
  email: "",
  password: "",
};

interface LoginFormProps extends AuthReducerProps {}

function LoginForm(props: LoginFormProps) {
  const history = useHistory();

  const [formLoading, setFormLoading] = useState(false);

  const url = new URL(window.location.href);
  const domain = url.hostname.replace(/^www\./, '');
  const aiDomain = process.env.REACT_APP_SCRIBE_BASE_URL;

  const onSubmit = (values: FormikValues) => {
    setFormLoading(true);
    AuthService.getUserRole(
      values.email,
      (userRole: UserRoleEnum) => {
        let homeURL = AppRoutes.HOME;
        if(domain === aiDomain) {
          homeURL = AppRoutes.REPORTS_LIST;
        }
        switch (userRole) {
          case UserRoleEnum.DOCTOR: {
            const doctor = Object.assign(new Doctor(), values);
            AuthService.doctorLogin(
              doctor,
              () => {
                  history.push(homeURL);
              },
              () => {},
              () => {
                setFormLoading(false);
              }
            );
            break;
          }
          case UserRoleEnum.ADMIN: {
            const admin = Object.assign(new Admin(), values);
            AuthService.adminLogin(
              admin,
              () => {
                history.push(homeURL);
              },
              () => {},
              () => {
                setFormLoading(false);
              }
            );
            break;
          }
          case UserRoleEnum.SCAN_CENTER: {
            const scanCenter = Object.assign(new ScanCenter(), values);
            AuthService.scanCenterLogin(
              scanCenter,
              () => {
                history.push(homeURL);
              },
              () => {},
              () => {
                setFormLoading(false);
              }
            );
            break;
          }
        }
      },
      () => {
        setFormLoading(false);
      },
      () => {}
    );
  };

  return (
    <div className="login-form">
      <img src={RadiolinqLogo} className="logo-form__logo-image" />
      <h1>Login</h1>
      <Formik
        initialValues={initialValue}
        onSubmit={onSubmit}
        validationSchema={loginFormValidation}
      >
        <Form>
          <InputField type="email" name="email" placeholder="Enter email" />
          <InputField
            type="password"
            name="password"
            placeholder="Enter password"
          />
          <Button htmlType="submit" loading={formLoading}>
            Login
          </Button>
        </Form>
      </Formik>
    </div>
  );
}

export default AuthContainer(LoginForm);
